module.exports = __webpack_public_path__ + "img/settings-establishment.77e3c18b.svg";